import { useEffect } from "react";

import FormFieldViewText from "components/FormFields/ViewText";
import { Space } from "components/icons/generated";
import MetaInfoListItem from "components/MetaInfoList/Item";
import TagsList from "components/TagsList";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormField from "ds/components/Form/Field";
import { TrackAnalyticsEventProperties } from "shared/Analytics";
import { getDuration } from "utils/time";

import { AwsIntegrationView } from "../../useSearchCloudIntegrations/gql";

type AwsIntegrationDetailsProps = {
  integration: AwsIntegrationView;
  trackAnalytics: (event: string, props?: TrackAnalyticsEventProperties) => void;
};

const AwsIntegrationDetailsDrawer = createDrawer(
  ({ integration, trackAnalytics }: AwsIntegrationDetailsProps) => {
    useEffect(() => {
      trackAnalytics("Open Integration Details", { type: "aws" });
    }, [trackAnalytics]);

    return (
      <DrawerSimple>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Details" />
          <DrawerCloseIcon />
        </DrawerHeader>

        <DrawerBody>
          <FormFieldViewText label="Name" value={integration.name} />

          <FormField label="Space">
            <MetaInfoListItem
              icon={Space}
              linkText={integration.spaceDetails.name}
              href={`/spaces/${integration.spaceDetails.id}`}
            />
          </FormField>

          <FormFieldViewText label="Role ARN" value={integration.roleArn} withCopy />

          <FormFieldViewText label="Duration" value={getDuration(integration.durationSeconds)} />

          <FormFieldViewText label="Region" value={integration.region} />

          <FormFieldViewText
            label="Assume role on worker"
            value={integration.generateCredentialsInWorker ? "Yes" : "No"}
          />
          <FormFieldViewText
            label="Enable tag session"
            value={integration.tagAssumeRole ? "Yes" : "No"}
          />

          {integration.generateCredentialsInWorker && (
            <FormFieldViewText label="External ID" value={integration.externalId} withCopy />
          )}

          {integration.labels.length > 0 && (
            <FormField label="Labels">
              <TagsList tags={integration.labels} alwaysExpanded />
            </FormField>
          )}
          <FormFieldViewText
            label="Auto-attach enabled"
            value={integration.autoattachEnabled ? "Yes" : "No"}
          />
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showAwsIntegrationDetailsDrawer = createDrawerTrigger(AwsIntegrationDetailsDrawer);
